import "@vitejs/plugin-react/preamble"
import { ToastProvider } from "@heroui/react"
import { createRoot } from "react-dom/client"
import { SignInPage } from "~/app/pages/SignInPage"

const el = document.getElementById("app-signin-root")
if (el) {
  createRoot(el).render(
    <>
      <SignInPage
        confirmationError={el.dataset.confirmationError || undefined}
        confirmed={el.dataset.confirmed === "true"}
        passwordReset={el.dataset.passwordReset === "true"}
        redirectTo={el.dataset.redirect || "/dashboard"}
        resetSent={el.dataset.resetSent === "true"}
      />
      <ToastProvider placement="top" />
    </>,
  )
}
